<template>
  <div id="app">
    <transition name="apps" mode="out-in" appear>
      <router-view />
    </transition>
  </div>
</template>
<script>
export default {
  name: "App",
  created() {},
}
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body,
#app {
  height: 100%;
  background-color: #f2f7fa;
}

a {
  color: #707070;
  text-decoration: none;
}

.apps-enter-active,
.apps-leave-active {
  transition: opacity 0.3s;
}

.apps-enter,
.apps-leave-to {
  opacity: 0;
}
</style>
